import React, { useEffect, useState } from 'react';
import { Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import api from '../services/api';
import { getStripe } from '../services/stripe';

function FormulairePaiement({ montant, onPaye }) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [erreur, setErreur] = useState('');

  async function soumettre(e) {
    e.preventDefault();
    setErreur('');
    if (!stripe || !elements) return;

    setLoading(true);
    try {
      const result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: window.location.origin + '/mes-commandes'
        },
        redirect: 'if_required'
      });

      if (result.error) {
        setErreur(result.error.message || 'Erreur paiement');
      } else {
        onPaye?.(result.paymentIntent);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={soumettre} className="grid gap-4">
      <PaymentElement />
      {erreur ? <div className="rounded-xl border border-rose-200 bg-rose-50 p-3 text-sm text-rose-700">{erreur}</div> : null}
      <button
        disabled={!stripe || loading}
        className="rounded-2xl bg-marega-600 px-5 py-4 text-sm font-semibold text-white shadow-lg shadow-marega-600/20 hover:bg-marega-500 disabled:opacity-50"
      >
        {loading ? 'Paiement...' : `Payer ${montant}`}
      </button>
    </form>
  );
}

export default function BoutonPaiementCarte({ montant, devise = 'eur', onPaye, onIntent }) {
  const [clientSecret, setClientSecret] = useState('');
  const [paiementId, setPaiementId] = useState('');
  const [erreur, setErreur] = useState('');

  useEffect(() => {
    let mounted = true;

    async function creer() {
      setErreur('');
      try {
        const { data } = await api.post('/paiement/carte', { montant, devise });
        if (!mounted) return;
        setClientSecret(data.clientSecret);
        setPaiementId(data.paiement_id);
        onIntent?.(data);
      } catch (e) {
        if (!mounted) return;
        setErreur(e?.response?.data?.message || 'Impossible de créer le paiement Stripe');
      }
    }

    if (montant > 0) creer();

    return () => {
      mounted = false;
    };
  }, [montant, devise, onIntent]);

  if (erreur) {
    return <div className="rounded-2xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-700">{erreur}</div>;
  }

  if (!clientSecret) {
    return <div className="rounded-2xl border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600">Préparation du paiement...</div>;
  }

  return (
    <div className="rounded-3xl border border-gray-200 bg-white p-6">
      <div className="mb-4 text-sm font-semibold text-gray-900">Paiement par carte</div>
      <Elements stripe={getStripe()} options={{ clientSecret }}>
        <FormulairePaiement montant={montant} onPaye={(pi) => onPaye?.({ paiementId, paymentIntent: pi })} />
      </Elements>
    </div>
  );
}
